import { get, chain, replace, startsWith } from "lodash"
import { createSelector } from "reselect"
import { getSelectedDate } from "modules/watchlist/selectors"
import {
  createGetClassificationsTiersSelector,
  createGetClassificationsSelector,
  createGetCountriesMapSelector,
  createGetCurrenciesMapSelector,
  createGetCountriesSelector,
  createGetClassificationFacetsSelector,
  createGetSelectedClassificationsSelector,
  createGetSelectedClassificationsFilteredSelector,
  createGetClassificationFacetTreesSelector,
  createGetCurrenciesSelector,
  createGetFacetTypesSelector,
} from "helpers/facetSelectors"

export const getRawClassifications = state => get(state, "global.data.classifications.data.classifications")
const getModelCountries = state => get(state, "global.data.modelCountries.data")
const getModelCurrencies = state => get(state, "global.data.modelCurrencies.data")
const getRawCountries = state => get(state, "global.data.watchlistFacets.data.model.securitySearch.countries")
const getRawCurrencies = state => get(state, "global.data.watchlistFacets.data.model.securitySearch.currencies")

const getRawClassificationsValues = state => get(state, "global.data.classificationsValues.data")
const getRawClassificationsFacets = state => get(state, "global.data.watchlistFacets.data.model.securitySearch")
const getSelectedCountries = state => state.modules.watchlistFacets.country
const getSelectedCurrencies = state => state.modules.watchlistFacets.currency
const getRawSelectedClassifications = state => state.modules.watchlistFacets.classifications

const getClassificationsFacets = createSelector(
  [getRawClassificationsFacets],
  (classificationFacets) => chain(classificationFacets)
    .pickBy((i, key) => startsWith(key, "classification_"))
    .mapKeys((i, key) => replace(key, "classification_", ""))
    .value(),
)

const getClassificationsTiers = createGetClassificationsTiersSelector(getRawClassifications, getSelectedDate)
export const getClassifications = createGetClassificationsSelector(getRawClassificationsValues, getClassificationsTiers)
const getCountriesMap = createGetCountriesMapSelector(getModelCountries)
const getCurrenciesMap = createGetCurrenciesMapSelector(getModelCurrencies)
export const getCountries = createGetCountriesSelector(getRawCountries, getCountriesMap, getSelectedCountries)
export const getClassificationFacets = createGetClassificationFacetsSelector(getClassificationsFacets, getClassifications)
export const getSelectedClassifications = createGetSelectedClassificationsSelector(getClassificationFacets, getRawSelectedClassifications)
export const getSelectedClassificationsFiltered = createGetSelectedClassificationsFilteredSelector(getSelectedClassifications, getClassifications)
export const getClassificationFacetTrees = createGetClassificationFacetTreesSelector(getClassificationFacets, getClassificationsTiers, getSelectedClassifications)
export const getCurrencies = createGetCurrenciesSelector(getRawCurrencies, getCurrenciesMap, getSelectedCurrencies)
export const getFacetTypes = createGetFacetTypesSelector(getCountries, getCurrencies, getClassificationFacetTrees, getSelectedClassificationsFiltered)
